/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MfaEnablePost200Response
 */
export interface MfaEnablePost200Response {
    /**
     * 
     * @type {string}
     * @memberof MfaEnablePost200Response
     */
    secret?: string;
    /**
     * 
     * @type {string}
     * @memberof MfaEnablePost200Response
     */
    qrCodeUri?: string;
    /**
     * 
     * @type {string}
     * @memberof MfaEnablePost200Response
     */
    message?: string;
}

export function MfaEnablePost200ResponseFromJSON(json: any): MfaEnablePost200Response {
    return MfaEnablePost200ResponseFromJSONTyped(json, false);
}

export function MfaEnablePost200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MfaEnablePost200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'secret': !exists(json, 'secret') ? undefined : json['secret'],
        'qrCodeUri': !exists(json, 'qrCodeUri') ? undefined : json['qrCodeUri'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function MfaEnablePost200ResponseToJSON(value?: MfaEnablePost200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'secret': value.secret,
        'qrCodeUri': value.qrCodeUri,
        'message': value.message,
    };
}

